<template>
  <nav class="navbar" role="navigation" aria-label="main navigation">
    <div class="container">
      <div class="navbar-brand">
        <a class="navbar-item" href="https://bulma.io">
          <img src="../assets/logo.png" width="112" height="28" />
        </a>

        <a
          role="button"
          class="navbar-burger burger"
          aria-label="menu"
          aria-expanded="false"
          data-target="navbarBasicExample"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <div id="navbarBasicExample" class="navbar-menu">
        <div class="navbar-end">
          <a class="navbar-item scroll" href="#about">About Us</a>
          <a class="navbar-item scroll" href="#coverage">Our Coverage</a>
          <a class="navbar-item scroll" href="#brands">Our Brands</a>
          <a class="navbar-item scroll" href="#contact">Contact</a>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
	name: 'Navbar'
}
</script>

<style lang="css">
.navbar {
	padding-top: 20px;
	padding-bottom: 20px;
}
.navbar-item img {
    max-height: none;
    position: relative;
    top: -2px;
}
</style>
